var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"is-rounded":true,"type":"button","is-small":true,"is-default":true},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Skapa ny överlåtelse som "),_c('strong',[_vm._v("mäklare")])])
}
var staticRenderFns = []

export { render, staticRenderFns }